import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  output,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { v4 as uuid } from 'uuid';
import { PalantirTextComponent } from '../text/text.component';

@Component({
  selector: 'palantir-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PalantirTextComponent],
  host: {
    '[class.palantir-toggle-inverted]': 'inverted()',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PalantirToggleComponent),
      multi: true,
    },
  ],
})
export class PalantirToggleComponent implements ControlValueAccessor {
  public toggleChange = output<boolean>();

  public disabled = input<boolean>(false);

  public inverted = input<boolean>(false);

  public label = input<string>('');

  public value = signal<boolean>(false);

  public checked = this.value.asReadonly();

  public uniqueId = uuid();

  public writeValue(obj: boolean): void {
    this.value.set(obj);
  }

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public onChangeFn: any = () => {};

  public onTouchedFn: any = () => {};

  public toggle(): void {
    if (this.disabled()) {
      return;
    }

    this.value.set(!this.value());
    this.onChangeFn(this.value());
    this.toggleChange.emit(this.value());
  }
}
